import { useMemo } from 'react';

export const useIsChrome = () => {
  const isChrome = useMemo(
    // @ts-ignore
    () => !!window.chrome,
    // @ts-ignore
    [window.chrome],
  );

  return isChrome;
};
